import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import FromLayout from "../../component/FromLayout";
import { useResetPasswordMutation } from "../../store/api/authSlice";
import { handleApiError } from "../../utils/dateAndTimeConversion";
import { useTranslation } from "react-i18next";

const ResetPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const [form, setForm] = useState({ password: "", cpassword: "" });
  const [errors, setErrors] = useState({ password: "", cpassword: "" });
  const [resetPassword, { isLoading }] = useResetPasswordMutation();

  const handleChange = (e) => {
    const { name, value } = e.target;

    // update field value
    setForm((prev) => ({ ...prev, [name]: value }));

    // clear that field’s error as user types
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const newErrors = { password: "", cpassword: "" };
    let isValid = true;

    if (!form.password) {
      newErrors.password = `${t("please")} ${t("enter")} ${t("password")}`;

      isValid = false;
    }

    if (!form.cpassword) {
      newErrors.cpassword = `${t("please")} ${t("enter")} ${t("confirm")} ${t("password")}`;

      isValid = false;
    } else if (form.password !== form.cpassword) {
      newErrors.cpassword = `${t("password")} ${t("and")} ${t("confirm_password")} ${t("do_not_match")}`;
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    toast.dismiss();

    try {
      const response = await resetPassword({
        newPassword: form.password,
        email: location?.state?.email,
      }).unwrap();
      console.log(response?.message);
      toast.success("Password reset successfully");
      navigate("/");
    } catch (error) {
      handleApiError(error);
    }
  };
  return (
    <FromLayout title="Reset Password" width="w-40">
      <div className="text-center mb-5">
        <p
          className="text-light"
          style={{ opacity: 0.8, maxWidth: "500px", margin: "0 auto" }}
        >
          {t("please")} {t("enter")} {t("your")} {t("new")} {t("password")}{" "}
          {t("here")}
        </p>
      </div>
      <div>
        <form onSubmit={handleSubmit}>
          <div className="row g-4 text-start mb-4">
            <div className="col-12">
              <label className="form-label text-white">{t("password")}</label>
              <div className="input-group mb-1">
                <input
                  type="password"
                  className="form-control"
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder={`${t("enter")} ${t("your")} ${t("password")}`}
                />
              </div>
              {errors.password && (
                <span style={{ color: "red" }}>{errors.password}</span>
              )}
            </div>

            <div className="col-12">
              <label className="form-label text-white">
                {t("confirm")} {t("password")}
              </label>
              <div className="input-group mb-1">
                <input
                  type="password"
                  className="form-control"
                  name="cpassword"
                  value={form.cpassword}
                  onChange={handleChange}
                  placeholder={`${t("confirm")} ${t("your")} ${t("password")}`}
                />
              </div>
              {errors.cpassword && (
                <span style={{ color: "red" }}>{errors.cpassword}</span>
              )}
            </div>

            <div className="col-12">
              <button
                type="submit"
                className="btn btn-amber rounded-3 px-4 w-100"
                disabled={isLoading}
              >
                {isLoading ? (
                  <div className="spinner-border" role="status">
                    <span className="sr-only p-0"></span>
                  </div>
                ) : (
                  t("btns.submit")
                )}
              </button>
            </div>
          </div>
        </form>
      </div>

      {/* <div className='text-center loginText text-white'>
        Didn't receive? <a href='#'>Resend</a>
      </div> */}

      {/* Add custom styles for transparent checkbox */}
      <style jsx>{`
        .form-check-input {
          background-color: transparent !important;
          border: 1px solid #fff !important;
        }

        .form-check-input:checked {
          background-color: #f0b241 !important;
          border-color: #f0b241 !important;
        }

        .form-check-input:focus {
          box-shadow: 0 0 0 0.2rem rgba(240, 178, 65, 0.25) !important;
        }
      `}</style>
    </FromLayout>
  );
};

export default ResetPassword;
